import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8f056932"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-weekly-input-container"
};
const _hoisted_2 = {
  class: "ba-weekly-budget ba-text ba-text-left"
};
const _hoisted_3 = ["disabled"];
const _hoisted_4 = {
  class: "ba-weekly-info"
};
const _hoisted_5 = ["id"];
const _hoisted_6 = {
  class: "ba-weekly-badge-price ba-text ba-text-purple ba-text-lighter"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Apply AI recommendation ", -1));
const _hoisted_8 = {
  key: 0,
  class: "ba-weekly-sufix ba-text ba-text-gray"
};
const _hoisted_9 = {
  class: "ba-weekly-icon"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " Reset value ", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tooltip-text"
}, " AI recommended value ", -1));
const _hoisted_12 = {
  key: 0,
  class: "budget-error"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["ba-weekly-input", {
      'ba-weekly-custom': $options.isCustom,
      'ba-weekly-disabled': $props.disabled,
      'ba-weekly-no-sufix': !$props.sufix || $props.sufix === '',
      'error': $options.validation.status !== 'success'
    }])
  }, [_createElementVNode("div", {
    class: _normalizeClass(['ba-weekly-value', {
      editing_value: $data.editing_value
    }, {
      'error': $options.validation.status !== 'success'
    }]),
    onClick: _cache[5] || (_cache[5] = (...args) => $options.onCurrencyValueClick && $options.onCurrencyValueClick(...args))
  }, [_createElementVNode("div", _hoisted_2, [!$data.editing_value ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [$props.percentage ? (_openBlock(), _createBlock(_component_percentage_value, {
    key: 0,
    value: $options.localModelValue / 100,
    onClick: $options.onCurrencyValueClick,
    type: "ba_table",
    style: {
      "cursor": "pointer"
    }
  }, null, 8, ["value", "onClick"])) : (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $options.localModelValue,
    currency: $props.currency,
    precision: 2,
    allowPrecisionModification: false,
    onClick: $options.onCurrencyValueClick,
    style: {
      "cursor": "pointer"
    }
  }, null, 8, ["value", "currency", "onClick"]))], 64)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    style: {
      "font-size": "13px",
      "color": "rgb(0,0,0) !important"
    },
    class: _normalizeClass(["input-container", {
      percentage: $props.percentage
    }])
  }, [_createTextVNode(_toDisplayString(!$props.percentage ? $data.currency_symbol : "%") + " ", 1), _withDirectives(_createElementVNode("input", {
    ref: "editInput",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.localModelValue = $event),
    type: "text",
    disabled: $props.disabled,
    onInput: _cache[1] || (_cache[1] = (...args) => $options.onInput && $options.onInput(...args)),
    onKeydown: _cache[2] || (_cache[2] = (...args) => $options.isNumber && $options.isNumber(...args)),
    onFocusout: _cache[3] || (_cache[3] = $event => $data.editing_value = false)
  }, null, 40, _hoisted_3), [[_vModelText, $options.localModelValue]])], 2))]), _createElementVNode("div", _hoisted_4, [_withDirectives(_createElementVNode("div", {
    class: "ba-weekly-badge",
    id: `sp_sidebar_input_ai_recommend_${$data.random_id}`,
    onClick: _cache[4] || (_cache[4] = (...args) => $options.onReset && $options.onReset(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "ai",
    size: 14,
    color: "#8D85E5"
  }), _createElementVNode("div", _hoisted_6, [$props.percentage ? (_openBlock(), _createBlock(_component_percentage_value, {
    key: 0,
    value: $props.ai / 100
  }, null, 8, ["value"])) : (_openBlock(), _createBlock(_component_currency_value, {
    key: 1,
    value: $props.ai,
    currency: $props.currency,
    precision: 2,
    allowPrecisionModification: false
  }, null, 8, ["value", "currency"]))])], 8, _hoisted_5), [[_vShow, $options.isCustom]]), _createVNode(_component_app_popover, {
    target: `sp_sidebar_input_ai_recommend_${$data.random_id}`,
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_7]),
    _: 1
  }, 8, ["target"]), $props.sufix && $props.sufix != '' ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($props.sufix), 1)) : _createCommentVNode("", true)])], 2), _createElementVNode("div", _hoisted_9, [_withDirectives(_createVNode(_component_app_icon, {
    icon: "ai",
    size: 16,
    color: "#5A52AE",
    id: `sp_sidebar_input_ai_${$data.random_id}`
  }, null, 8, ["id"]), [[_vShow, !$options.isCustom]]), _withDirectives(_createElementVNode("div", {
    class: "ba-weekly-icon-reset",
    onClick: _cache[6] || (_cache[6] = (...args) => $options.onReset && $options.onReset(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "gear",
    size: 16,
    color: "#4C8EFF",
    class: "gear"
  }), _createVNode(_component_app_icon, {
    icon: "reset",
    size: 16,
    color: "#4C8EFF",
    class: "reset",
    id: `sp_sidebar_input_reset_${$data.random_id}`
  }, null, 8, ["id"])], 512), [[_vShow, $options.isCustom]]), _createVNode(_component_app_popover, {
    target: `sp_sidebar_input_reset_${$data.random_id}`,
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  }, 8, ["target"]), _createVNode(_component_app_popover, {
    target: `sp_sidebar_input_ai_${$data.random_id}`,
    placement: "top"
  }, {
    default: _withCtx(() => [_hoisted_11]),
    _: 1
  }, 8, ["target"])])], 2), $options.validation.text ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString($options.validation.text), 1)) : _createCommentVNode("", true)]);
}